

















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import { UserInfo } from "../../_models/userInfo";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { dataService } from "../../_services";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class AdminPage extends Vue {
  // private userData: UserInfo;
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;

  constructor() {
    super();
    this.titleParams = {
      title: "Elenco Utenti",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [],
      records: [],
      dialogParams: {
        title: "DETTAGLI UTENTE",
        type: "userTab"
      }
    };
    this.createDialogParams = {
      visible: true,
      type: "nuovoUtente"
    };
  }

  loadUserList() {
    var userInfo = user.readUserInfo(this["$store"]);
    var userList: UserInfo[] = [];
    var roles: number[] = [];
    var descRoles: string[] = [];
    var payload = {
      idEntità: 0,
      idTipoSoggetto: 0
    };
    if (userInfo.tipoSoggetto === 2) {
      var instituteInfo = user.readInstituteInfo(this["$store"]);
      payload = {
        idEntità: instituteInfo.id,
        idTipoSoggetto: 2
      };
      data
        .dispatchUsersList(this["$store"], payload)
        .then(result => {
          this.dataTableParams.headers = [
            {
              text: "Nome",
              value: "nomeUtente"
            },
            {
              text: "Cognome",
              value: "cognomeUtente"
            },
            // {
            //   text: "Utente",
            //   value: "action"
            // },
            {
              text: "Ruolo",
              value: "descrizioneRuolo"
            },
            {
              text: "Dettagli",
              value: "action",
              sortable: false
            },
            {
              text: "Assegna Ruoli",
              value: "editUserRoles",
              sortable: false
            }
          ];
          this.dataTableParams.records = result;
          bus.$emit("dataLoaded");
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nel caricamento della lista utenti"
            );
          }
        });
    } else if (userInfo.tipoSoggetto === 3) {
      var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
      payload = {
        idEntità: enterpriseInfo.idAzienda,
        idTipoSoggetto: 3
      };
      data
        .dispatchUsersList(this["$store"], payload)
        .then(result => {
          this.dataTableParams.headers = [
            {
              text: "Nome",
              value: "nomeUtente"
            },
            {
              text: "Cognome",
              value: "cognomeUtente"
            },
            // {
            //   text: "Utente",
            //   value: "action"
            // },
            {
              text: "Ruolo",
              value: "descrizioneRuolo"
            },
            {
              text: "Dettagli",
              value: "action",
              sortable: false
            },
            {
              text: "Assegna Ruoli",
              value: "editUserRoles",
              sortable: false
            }
          ];
          this.dataTableParams.records = result;
          bus.$emit("dataLoaded");
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit(
              "errorOperation",
              "Errore nel caricamento della lista utenti"
            );
          }
        });
    } else {
      bus.$emit("errorOperation", "Errore nel caricamento della lista utenti");
    }
  }

  parseToken(token: string): JSON {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function(c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  created() {
    //chiamata al servizio per ottenere la lista utenti
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = this.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        if (payload.tipoSoggetto === 2) {
          user
            .dispatchSetInstituteInfo(this["$store"])
            .then(() => {
              this.loadUserList();
              bus.$emit("loadMenu");
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        } else if (payload.tipoSoggetto === 3) {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              this.loadUserList();
              bus.$emit("loadMenu");
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        } else {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/login");
          bus.$emit("errorOperation", "Errore nel caricamento dati");
        }
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadUserList", () => {
      this.loadUserList();
    });
  }
}
